import React from "react";
import { createRoot } from "react-dom/client";
import "./styles";
import Main from "main";
createRoot(document.querySelector("#content")).render(React.createElement(Main, null));
